import {
  Box,
  Button,
  Chip,
  FormControlLabel,
  FormGroup,
  IconButton,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import styles from "../postModal/css/BottomContainer.module.css";
import { useTranslation } from "react-i18next";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useState } from "react";
import DoneButton from "../shared/ui/Modal/DoneButton";
import LocationModal from "../LocationModal/LocationModal";
import { styled } from "@mui/material/styles";
import { validateFileSize } from "../../../redux/constants/commonFunctions";
import CloseIcon from "@mui/icons-material/Close";
import { useContext } from "react";
import { FeedsContext } from "../Components/FeedsContext";
import { GroupFeedsContext } from "../../ClassesGroups/CreateClass/GroupFeedsContext";
import Alert from "@material-ui/lab/Alert";
import { Snackbar } from "@material-ui/core";
import { categoryList } from "../../../template/DummyData";

const GoogleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const donateAmounts = ["None", "10%", "50%", "100%"];

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const SellModal = ({
  show,
  setShowSellModal,
  pic,
  updateSellPost,
  updateCoordinates,
  sellPost,
  actionType,
  postId,
}) => {
  const address = JSON.parse(localStorage.getItem("address"));
  const lat = JSON.parse(localStorage.getItem("lat"));
  const lng = JSON.parse(localStorage.getItem("lng"));
  const { t } = useTranslation();
  const [sellDetails, setSellDetails] = useState(
    sellPost || {
      photos: [],
      photoUrls: [],
      title: "",
      desc: "",
      category: "",
      pickLocation: address,
      price: "",
      isFree: true,
      discountedPrice: "",
      discountOff: "",
      // donationCenter: "Parkinson's Institute and Clinical Center",
      // donationAmt: "none",
    }
  );
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [coordinates, setCoordinates] = useState({
    lat: lat,
    lng: lng,
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const source = localStorage.getItem("source");

  const { deleteSellImage } = useContext(
    source == "GROUP" ? GroupFeedsContext : FeedsContext
  );

  console.log(sellDetails);

  useEffect(() => {
    setSellDetails((prev) => ({
      ...prev,
      discountOff: (
        ((sellDetails.price - sellDetails.discountedPrice) /
          sellDetails.price) *
        100
      ).toFixed(2),
    }));
  }, [sellDetails.discountedPrice]);

  const fileInput = (e) => {
    if (e.target.files[0]) {
      const errorMessage = validateFileSize(e.target.files[0], 5120);
      if (errorMessage) {
        setOpenSnackbar(true);
        setAlertMessage("Only Images lower than 5MB are allowed!");
      } else {
        setSellDetails((prev) => ({
          ...prev,
          photos: [
            ...prev.photos,
            { id: sellDetails?.photos?.length + 1, src: e.target.files[0] },
          ],
          photoUrls: [
            ...prev.photoUrls,
            {
              id: sellDetails?.photoUrls?.length + 1,
              src: URL.createObjectURL(e.target.files[0]),
            },
          ],
        }));
      }
    }
  };

  const handleChange = (event) => {
    setSellDetails((prev) => ({ ...prev, category: event.target.value }));
  };

  const handleAddress = (address) => {
    setSellDetails((prev) => ({ ...prev, pickLocation: address }));
  };

  const handleSubmit = () => {
    updateSellPost(sellDetails);
    updateCoordinates({
      lat: coordinates.lat,
      lng: coordinates.lng,
      address: sellDetails.pickLocation,
    });
    setShowSellModal(false);
  };

  const handleCoordinatesChange = (coor) => {
    setCoordinates(coor);
  };

  const handleRemoveImage = (id) => {
    console.log(id);
    setSellDetails((prev) => {
      const photos = prev.photos.filter((img) => img.id !== id);
      const photoUrls = prev.photoUrls.filter((img) => img.id !== id);
      return { ...prev, photos: photos, photoUrls: photoUrls };
    });
    if (actionType === "EDIT") {
      deleteSellImage(id, postId);
    }
  };

  return (
    <>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="error"
          sx={{ width: "100%" }}
          variant="filled"
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      <LocationModal
        show={showLocationModal}
        closeModal={() => setShowLocationModal(false)}
        method={handleAddress}
        coordinates={coordinates}
        setCoordinates={handleCoordinatesChange}
      />
      <Box>
        <form onSubmit={handleSubmit}>
          <Box
            sx={{
              padding: "15px 25px",
              maxHeight: "60vh",
              overflowY: "scroll",
            }}
          >
            <Box
              sx={{
                position: "relative",
                maxHeight: "25vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <img
                src="/Image/DashboardImages/postModImages/post_sell.png"
                alt="event cover"
                style={{ objectFit: "contain", height: "25vh" }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 1,
                overflowX: sellDetails.photos.length < 5 ? "hidden" : "scroll",
                overflowY: "hidden",
                paddingBottom: 2,
              }}
            >
              {sellDetails.photoUrls.map((photo) => (
                <Box key={photo.id} sx={{ position: "relative" }}>
                  <img
                    src={photo.src}
                    alt="sellImage"
                    style={{
                      width: "120px",
                      height: "120px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                  <IconButton
                    onClick={() => handleRemoveImage(photo.id)}
                    disableRipple
                    sx={{
                      position: "absolute",
                      right: 5,
                      background: "#666",
                      padding: "5px",
                      top: 5,
                      ":hover": {
                        background: "#666",
                      },
                    }}
                  >
                    <CloseIcon fontSize="small" sx={{ color: "#fff" }} />
                  </IconButton>
                </Box>
              ))}
              {sellDetails.photos.length <= 10 ? (
                <Box
                  sx={{
                    minHeight: "120px",
                    background: "#E5E5E5",
                    borderRadius: "8px",
                    minWidth: "120px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <input
                    onChange={fileInput}
                    type="file"
                    accept="image/*"
                    className={styles.fileUpload}
                  />
                  <AddPhotoAlternateOutlinedIcon
                    sx={{ color: "#000", fontSize: "24px" }}
                  />
                  <Typography
                    sx={{
                      fontWeight: 500,
                      color: "primary.black",
                      fontSize: "15px",
                    }}
                  >
                    Add photo
                  </Typography>
                </Box>
              ) : null}
            </Box>
            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: 400,
                lineHeight: "16px",
              }}
            >
              Add up to 10 photos. You can drag and drop.
            </Typography>

            <Typography sx={{ mt: 3, fontSize: "22px", fontWeight: 600 }}>
              What are you selling?
            </Typography>
            <TextField
              onChange={(e) =>
                setSellDetails((prev) => ({ ...prev, title: e.target.value }))
              }
              value={sellDetails.title}
              variant="filled"
              label="Title"
              sx={{ mt: 1, width: "98%" }}
              InputProps={{
                disableUnderline: true,
                sx: { borderRadius: "8px", background: "#E5E5E5" },
              }}
              InputLabelProps={{
                style: { color: "rgba(0,0,0,0.6)" },
              }}
            />
            <TextField
              onChange={(e) =>
                setSellDetails((prev) => ({ ...prev, desc: e.target.value }))
              }
              value={sellDetails.desc}
              variant="filled"
              label="Describe your item"
              sx={{ mt: 1, width: "98%" }}
              InputProps={{
                disableUnderline: true,
                sx: { borderRadius: "8px", background: "#E5E5E5" },
              }}
              InputLabelProps={{
                style: { color: "rgba(0,0,0,0.6)" },
              }}
            />

            <Typography sx={{ mt: 3, fontSize: "22px", fontWeight: 600 }}>
              Category
            </Typography>
            <FormControl sx={{ minWidth: 120 }}>
              <Select
                value={sellDetails.category}
                onChange={handleChange}
                displayEmpty
                inputProps={{
                  "aria-label": "Without label",
                  sx: {
                    padding: "16.5px 0px",
                    display: "flex",
                    alignItems: "center",
                  },
                }}
                sx={{
                  ".MuiOutlinedInput-notchedOutline": { border: 0 },
                  fontSize: "17px",
                  fontWeight: 600,
                  lineHeight: "24px",
                  "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                    {
                      border: 0,
                    },
                }}
              >
                <MenuItem
                  value=""
                  sx={{
                    fontSize: "17px",
                    fontWeight: 600,
                    lineHeight: "24px",
                    background: "none",
                  }}
                >
                  <img
                    src="/Image/CategoryIcons/Other.svg"
                    alt="select category"
                    style={{ marginRight: 8 }}
                  />
                  Select category
                </MenuItem>
                {categoryList.map((category, index) => (
                  <MenuItem
                    key={index}
                    value={category}
                    sx={{
                      fontSize: "17px",
                      fontWeight: 600,
                      lineHeight: "24px",
                      background: "none",
                    }}
                  >
                    <img
                      src={`/Image/CategoryIcons/${category}.svg`}
                      alt="select category"
                      style={{ marginRight: 8, width: "25px" }}
                    />
                    {category}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Typography sx={{ fontSize: "22px", fontWeight: 600 }}>
              Pickup Location
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: { lg: "row", xs: "column" },
              }}
            >
              <Chip
                icon={<LocationOnIcon color="#000" />}
                label={sellDetails?.pickLocation ? `${sellDetails?.pickLocation.slice(0, 37)}...` : "Select a location"}
                sx={{
                  mt: 1,
                  color: "#000",
                  fontSize: "15px",
                  fontWeight: 600,
                  lineHeight: "20px",
                }}
              />
              <Button
                onClick={() => setShowLocationModal(true)}
                disableRipple
                sx={{
                  ml: 1,
                  mt: 1,
                  ":hover": {
                    background: "none",
                  },
                  color: "#007A85",
                  fontSize: "15px",
                  fontWeight: 600,
                  lineHeight: "20px",
                  textTransform: "none",
                }}
              >
                Edit
              </Button>
            </Box>
            <Box>
              <img
                src={`https://maps.googleapis.com/maps/api/staticmap?center=${coordinates.lat},${coordinates.lng}&zoom=17&size=700x200&markers=icon:http://stage-nxnearby-assets.s3.ap-south-1.amazonaws.com/media/static/sale.png|${coordinates.lat},${coordinates.lng}&maptype=terrain&key=${GoogleMapsApiKey}&style=feature:administrative.land_parcel%7Celement:geometry.fill%7Cweight:4&style=feature:administrative.land_parcel%7Celement:labels.text.fill%7Ccolor:0xbdbdbd&style=feature:administrative.locality%7Celement:geometry.fill%7Cweight:5&style=feature:administrative.neighborhood%7Celement:geometry.fill%7Cweight:5.5&style=feature:administrative.province%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:landscape%7Celement:geometry.fill%7Ccolor:0xfcfcfc&style=feature:landscape.natural.landcover%7Celement:geometry.fill%7Ccolor:0xe9f7c4&style=feature:landscape.natural.terrain%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:poi%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:poi%7Celement:labels.text.stroke%7Ccolor:0xffffff&style=feature:poi.attraction%7Celement:geometry.fill%7Cweight:5&style=feature:poi.business%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:poi.government%7Celement:geometry.fill%7Ccolor:0xffdfba%7Cweight:4&style=feature:poi.medical%7Celement:geometry.fill%7Cweight:4.5&style=feature:poi.park%7Celement:geometry.fill%7Ccolor:0xbaffc9&style=feature:poi.park%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:poi.place_of_worship%7Cvisibility:off&style=feature:poi.place_of_worship%7Celement:geometry.fill%7Ccolor:0xffb3ba&style=feature:poi.school%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:poi.sports_complex%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:road%7Celement:geometry%7Ccolor:0xffffff&style=feature:road%7Celement:geometry.fill%7Clightness:10&style=feature:road.arterial%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:road.highway%7Celement:geometry%7Ccolor:0xdadada&style=feature:road.highway%7Celement:labels.text.fill%7Ccolor:0x616161&style=feature:road.local%7Celement:geometry.fill%7Ccolor:0xe0e0e0%7Clightness:40%7Cweight:5&style=feature:transit.line%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:transit.station%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:water%7Celement:geometry%7Ccolor:0xc9c9c9&style=feature:water%7Celement:geometry.fill%7Ccolor:0xc0faff&style=feature:water%7Celement:labels.text.fill%7Ccolor:0x9e9e9e`}
                style={{ marginTop: 16, borderRadius: 16, width: "95%" }}
              />
            </Box>
            <FormGroup sx={{ mt: 2 }}>
              <FormControlLabel
                control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
                label="Free"
                onChange={() =>
                  setSellDetails((prev) => ({
                    ...prev,
                    isFree: !sellDetails.isFree,
                  }))
                }
              />
            </FormGroup>

            {!sellDetails.isFree && (
              <>
                <Typography sx={{ fontSize: "22px", fontWeight: 600, mt: 2 }}>
                  Pricing
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <TextField
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, ""); // allow only numbers
                      setSellDetails((prev) => ({
                        ...prev,
                        price: value,
                        discountedPrice: 
                          prev.discountedPrice && Number(prev.discountedPrice) > Number(value)
                            ? "" // reset discounted if it's > price
                            : prev.discountedPrice,
                      }));
                    }}
                    value={sellDetails.price}
                    variant="filled"
                    placeholder="Price (INR)"
                    sx={{ mt: 1, width: "30%" }}
                    InputProps={{
                      disableUnderline: true,
                      sx: {
                        borderRadius: "8px",
                        background: "#E5E5E5",
                      },
                    }}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*", // mobile-friendly numeric input
                      style: {
                        padding: "16px",
                        fontSize: "17px",
                        fontWeight: 400,
                        lineHeight: "24px",
                      },
                    }}
                  />

                  <TextField
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, ""); // allow only numbers
                      if (Number(value) <= Number(sellDetails.price)) {
                        setSellDetails((prev) => ({
                          ...prev,
                          discountedPrice: value,
                        }));
                      }
                    }}
                    value={sellDetails.discountedPrice}
                    variant="filled"
                    placeholder="Discounted Price (INR)"
                    sx={{ mt: 1, width: "30%", ml: 3 }}
                    InputProps={{
                      disableUnderline: true,
                      sx: {
                        borderRadius: "8px",
                        background: "#E5E5E5",
                      },
                    }}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      style: {
                        padding: "16px",
                        fontSize: "17px",
                        fontWeight: 400,
                        lineHeight: "24px",
                      },
                    }}
                  />
                  {sellDetails.price !== "" &&
                  sellDetails.discountedPrice !== "" ? (
                    <Typography sx={{ ml: 2 }}>
                      {sellDetails.discountOff}% Off
                    </Typography>
                  ) : null}
                </Box>
              </>
            )}
            {/* <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 400,
                lineHeight: "20px",
                mt: 2,
              }}
            >
              Donate a portion to support
              <b> {sellDetails.donationCenter}.</b>
            </Typography>

            <Box sx={{ display: "flex", gap: 1, mt: 1, mb: 2 }}>
              {donateAmounts.map((amount, index) => (
                <Chip
                  onClick={() =>
                    setSellDetails((prev) => ({ ...prev, donationAmt: amount }))
                  }
                  key={index}
                  label={amount}
                  sx={{
                    cursor: "pointer",
                    mt: 1,
                    color: sellDetails.donationAmt === amount ? "#fff" : "#000",
                    fontSize: "15px",
                    fontWeight: 600,
                    lineHeight: "20px",
                    background:
                      sellDetails.donationAmt === amount
                        ? "#000"
                        : "rgba(0,0,0,0.08)",
                  }}
                />
              ))}
            </Box> */}
          </Box>
          <DoneButton
            backMethod={() => setShowSellModal(false)}
            type="submit"
          />
        </form>
      </Box>
    </>
  );
};

export default SellModal;
